/** Matches tailwind `cs-primary` */
export const CS_PRIMARY = '#1EAEDB';

/** Today tab: minimum height when a card has no rows so the appointments / meal plans columns stay balanced. */
export const DASHBOARD_TODAY_CARD_EMPTY_MIN_HEIGHT = 160;

export const DASHBOARD_ANALYTICS_DATE_RANGE_MAX_DAYS = 30;

export const DASHBOARD_TODAY_EMPTY_STATE_CONTAINER_SX = {
  flex: 1,
  minHeight: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
};

export const DASHBOARD_TODAY_EMPTY_STATE_TEXT_SX = {
  fontSize: '0.9375rem',
  fontWeight: 500,
  color: '#4a5565',
  textAlign: 'center',
  px: 1,
  lineHeight: 1.45,
};
